import type { QuoteDocumentPro, QuoteExportPayload } from './QuoteTypes'
import { proposalPdfGenerator, quoteProToClientPdf } from '@/modules/client-delivery/pdf'

/**
 * QuoteExporter — generates a client-facing PDF from QuoteDocumentPro.
 */
export class QuoteExporter {
  preparePdf(doc: QuoteDocumentPro): QuoteExportPayload {
    const client = quoteProToClientPdf(doc)
    const pdf = proposalPdfGenerator.generateFromClient(client)
    return {
      ok: true,
      format: 'pdf',
      quoteId: doc.id,
      title: doc.title,
      totals: doc.totals,
      itemCount: client.items.length,
      message: 'PDF gerado com sucesso',
      generatedAt: new Date().toISOString(),
      filename: pdf.filename,
      bytes: pdf.bytes,
    }
  }

  toJson(doc: QuoteDocumentPro): QuoteExportPayload & { payload: QuoteDocumentPro } {
    return {
      ...this.preparePdf(doc),
      format: 'json',
      message: 'Exportação JSON do Quote Builder PRO',
      payload: doc,
    }
  }
}

export const quoteExporter = new QuoteExporter()
